import {useContextSelector} from 'use-context-selector'
import {ExplorerContext} from '../context/ExplorerContext'

export function useEndereco() {
  const endereco = useContextSelector(ExplorerContext, (data) => data['endereco'])
  const OnSetEndereco = useContextSelector(ExplorerContext, (data) => data['OnSetEndereco'])
  return {endereco,OnSetEndereco}
}
